import http from './ajax';
export default {
  // 获取应用信息
  count(params) {
    return http.get('/api/key/effect/count', params);
  },

  // 应用信息查询
  serviceInfo(params) {
    return http.get('/api/flow/overrun/count_api', params);
  },

  // 添加应用key
  add(params) {
    return http.post('/api/key/mine/add', params);
  },

  // 编辑应用key
  edit(params) {
    return http.post('/api/key/mine/update', params);
  },

  // 获取应用信息
  getInfo(params) {
    return http.get('/api/key/mine/' + params + '');
  },

  // 移动用户Key
  move(params) {
    return http.post('/api/key/mine/move', params);
  },

  // 获取用户Key列表
  getList(params) {
    return http.get('/api/key/effect/list', params);
  },

  // 根据Key查询所有web可用api
  queryApi(params) {
    return http.get('/api/api/web/all', params);
  },

  // 查询所有服务平台
  platform(params) {
    return http.get('/api/key/platform/all', params);
  }

};
